
function ProductSprite(element, config) {
    
    this.element = element;
    this.config = config;
    this.config.frames = config.cols * config.rows;
    this.image = element.getAttribute('data-sprite');
    this.state = {
        'frame' : 0,
        'col' : 0,
        'pos' : 0,
        'loaded' : false,
        'playback' : null,
        'panMove' : null,
        'panMoveFrame' : null,
        'hasTrackedScrub': false
    };

    // setup events

    var self = this;
    this.element.addEventListener('mousedown', function(e) { e.preventDefault(); self.panStart(e.clientX); });
    this.element.addEventListener('mousemove', function(e) { e.preventDefault(); self.panMove(e.clientX); });
    document.addEventListener('mouseup', function(e) { e.preventDefault(); self.panEnd(e.clientX); });
    this.element.addEventListener('mouseout', function(e) { e.preventDefault(); self.panEnd(e.clientX); });

    this.element.addEventListener('touchstart', function(e) { e.preventDefault(); self.panStart(e.changedTouches[0].clientX); });
    this.element.addEventListener('touchmove', function(e) { e.preventDefault(); self.panMove(e.changedTouches[0].clientX); });
    this.element.addEventListener('touchend', function(e) { e.preventDefault(); self.panEnd(e.changedTouches[0].clientX); });
    this.element.addEventListener('touchcancel', function(e) { e.preventDefault(); self.panEnd(e.changedTouches[0].clientX); });
}

ProductSprite.prototype.panStart = function(position) {
    this.state.panMove = position;
    this.state.panMoveFrame = this.state.frame;
};

ProductSprite.prototype.panMove = function(position) {
    if(this.state.panMove !== null) {
        var panDelta = this.state.panMove - position;
        if(this.state.playback !== null && panDelta !== 0) {
            this.stop();
        }
        var frame = this.state.panMoveFrame + Math.round(panDelta / this.config.panSpeed);
        this.setFrame(frame);
        
        if(Math.abs(panDelta) > 100) {
            this.trackScrub();
        }
    }
};

ProductSprite.prototype.panEnd = function(position) {
    if(this.state.panMove === null) {
        return;
    }

    var panDelta = this.state.panMove - position;
    this.state.panMove = null;
    this.state.panMoveFrame = null;

    if(panDelta === 0) {
        if(this.state.playback !== null) {
            this.stop();
        } else {
            this.playback(this.state.frame+1 === this.config.frames);
        }
    }
};

ProductSprite.prototype.load = function() {
    if(this.state.loaded) {
        return;
    }
    this.element.style.backgroundImage = 'url('+this.image+')';
    this.state.loaded = true;
};

ProductSprite.prototype.start = function() {
    this.load();
    this.stop();
    this.playback(true);
};

ProductSprite.prototype.playback = function(resetFrame) {
    resetFrame = resetFrame || false;
    if(this.state.playback) {
        return;
    }

    this.state.panMove = null;
    this.state.panMoveFrame = null;

    if(resetFrame) {
        this.setFrame(0);
    }
    var self = this;
    this.state.playback = window.setInterval(function() {
        var next = self.state.frame+1;
        if(next === self.config.frames) {
            self.stop();
            return;
        }
        self.setFrame(next);
    }, this.config.duration);
};

ProductSprite.prototype.stop = function() {
    if(this.state.playback === null) {
        return;
    }
    window.clearInterval(this.state.playback);
    this.state.playback = null;
};

ProductSprite.prototype.setFrame = function(frame) {
    this.state.frame = frame % this.config.frames;
    this.state.row = Math.floor(frame / this.config.cols);
    this.state.col = this.state.frame % this.config.cols;
    this.element.style.backgroundPosition = (this.state.col * -this.config.width)+'px '+(this.state.row * -this.config.height)+'px';
};

ProductSprite.prototype.trackScrub = function() {
    if(this.state.hasTrackedScrub) {
        return;
    }
    window.gtag('event', 'product_360_scrub');
    this.state.hasTrackedScrub = true;
};